<template>
    <div class="flex flex-direction flex-sub padding-sm">
        <div class="bg-white padding flex-sub flex flex-direction align-center">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class=" form flex flex-direction" labelWidth="auto">
            <el-form-item label="旧密码" prop="password">
                <el-input v-model="ruleForm.password" placeholder="请输入旧密码" type="password"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="new_password">
                <el-input v-model="ruleForm.new_password" placeholder="请输入密码（需包含字母和数字8-20位）" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="agen_new_password">
                <el-input v-model="ruleForm.agen_new_password" placeholder="请再次输入密码" type="password"></el-input>
            </el-form-item>
            <el-button :loading="loading" type="primary" class="submit self-center" @click="submitForm('ruleForm')">确认修改</el-button>
        </el-form>
    </div>
    </div>
</template>

<script>

import {logout, TOAST, toast} from "@/utils/utils";
import rules from "@/utils/rules";
import {changeUserPass} from "@/api";

export default {
    name: "index",
    data() {
        let validatePassSame = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入登录密码'));
            } else if (value !== this.ruleForm.new_password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                password: '',
                new_password: '',
                agen_new_password: '',
            },
            rules: {
                password: [
                    {required: true, message: '请输入旧密码', trigger: 'change'},
                ],
                new_password: [
                    {required: true, message: '请输入新密码', trigger: 'change'},
                    rules.password
                ],
                agen_new_password: [
                    {required: true, message: '请输入确认密码', trigger: 'change'},
                    {validator: validatePassSame, trigger: 'change'},
                ],
            },
            loading: false,
        }
    },
    created() {
        this.$emit('setIndex', [9, 0])
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    components: {},
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submit();
                }
            });
        },
        async submit() {
            this.loading = true
            let _data = await changeUserPass(this.user.username,this.ruleForm.password,this.ruleForm.new_password,this.ruleForm.agen_new_password)
            this.loading = false
            if (_data.status === 200) {
                toast('修改成功，请重新登录', TOAST.success)
                logout()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
    }

}
</script>

<style lang="scss" scoped>
.wrapper {
    padding: 46px;

    .page-title {
        font-size: 24px;
        font-weight: bold;
        color: #333333;
        background: #ffffff;
        padding: 0 12px;
        z-index: 1;
        position: relative;

        &:after {
            position: absolute;
            content: '';
            width: 65px;
            height: 1px;
            background-color: #333333;
            top: 50%;
            left: -50%;
            transform: translateY(-50%);
        }

        &:before {
            position: absolute;
            content: '';
            width: 65px;
            height: 1px;
            background-color: #333333;
            top: 50%;
            right: -50%;
            transform: translateY(-50%);
        }
    }
}
</style>